import {
  Device,
  IAddImeiPayload,
  IAddImeiResponse,
  ICheckParams,
  IDeleteDevice,
  IParamsUnassignedImeis,
  IResponseUnassignedImeis,
} from '~/utils/interface/device';
import axiosClient from './axiosClient';

const url: string = '/api/devices';

const deviceApi = {
  getUnassignedImeis(params: IParamsUnassignedImeis) {
    return axiosClient.get<IResponseUnassignedImeis>(url + '/unassigned-imeis', { params });
  },
  checkDevice(params: ICheckParams) {
    return axiosClient.get(`/api/device/check`, { params });
  },
  updateDevice(data: Device) {
    return axiosClient.post(`/api/device/update`, data);
  },
  deleteDevice(data: IDeleteDevice) {
    return axiosClient.delete(`/api/device/delete`, { data });
  },
  getByInstallation(id: number) {
    return axiosClient.get(`/api/device/get-by-installation/${id}`);
  },
  getByUserList(username: string) {
    return axiosClient.get(`/api/device/list-by-user/${username}`);
  },
  addImei(data: IAddImeiPayload) {
    return axiosClient.post<IAddImeiResponse>('/api/devices/add-imei', data);
  },
};
export default deviceApi;
